/**
 * PaginationDot – SVG icon.
 */
import Colors from '@shared/assets/style/default/color';
import Props from '@shared/types/props/pressable';
import Screen from '@screen';

/** Focusable dot for carousel or list pagination. */
export default function PaginationDotIcon({ focused }: Props) {
  return (
    <>
      <svg
        width={15 * Screen.widthRatio}
        height={15 * Screen.widthRatio}
        viewBox={`0 0 ${15 * Screen.widthRatio} ${15 * Screen.widthRatio}`}
      >
        <circle
          cx={7.5 * Screen.widthRatio}
          cy={7.5 * Screen.widthRatio}
          r={7.5 * Screen.widthRatio}
          fill={focused ? Colors['selector'] : '#d9d9d980'}
        />
      </svg>
    </>
  );
}
